<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
        <figure>
          <img src="../../assets/images/amuda_agneswaran.jpg" alt="Amuda Agneswaran">
        </figure>
      <div class="finger-print">
        <img class="" src="@/assets/images/fingerprints/fingerprint-one.svg" alt="">
      </div>
      </div>
    </div>
  <div class="profile-statement">

      <h2>Amuda Agneswaran</h2>
      <p class="job-title">Lecturer</p>

      <p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

      <p>I am Amuda, a Lecturer in Psychology since October 2018. My journey at MMU started in 2015 when I came to Manchester from Mumbai, India to pursue my PhD. My name is of Tamil origin and means ‘Goddess of prosperity.’ I love the simple things in life, such as good food, dancing, sightseeing, and spending time with friends or with myself! I am an avid lover of Indian films and music and have trained for 12 years in Indian classical music. I speak five languages. My mother has been an influential figure in my life. Interestingly, most of the women from my maternal side are teachers.</p>

      <p class="profile-statement-interviewer">What inspires you within your role?</p>

      <p>What I really like about my role is that it is unique, not a ‘typical desk job.’ I have been entrusted with varied leadership roles such as Unit Leader, Admissions Lead, and Assessments’ support. Seeing my HOD and senior colleagues believe in me and give me such career progressing opportunities has inspired me to rise to the challenge and prove myself. My job has played a crucial role in developing my identity and purpose for life.</p>

      <p class="profile-statement-interviewer">What is something that you love about your culture or heritage? </p>

      <p>I have always been surrounded with people from varied communities and religions. People are surprised when I say that I enjoy celebrating Christmas as much as I do Diwali! That is what makes me proud of being an Indian. I love that I celebrate this diversity, through food, festivals, and speaking multiple languages. As the daughter of an Indian classical dancer, I have grown up hearing the beats of classical music and seeing colourful costumes. These dance forms are part of our rich culture, which makes me proud. The close family bonds, small aspects about our lifestyle and sense of community are important. I carry this with me always, even when I am in a foreign land.</p>

      <p class="profile-statement-interviewer">What does it look like to bring your whole self to your work?</p>

      <p>To answer in one word, it is colourful! Bringing my whole self means having the platform to be myself in every sense. My dressing style is the way I express my individuality to the world. Of course, there is the unmissable Indian accent! I find it enjoyable to exchange stories of common cultural practices with friends/colleagues, both local and international. When I teach, I aim to expose my students to the world beyond their own and introduce them to practices and biases that might be similar or dissimilar to their own. Being from another culture is definitely advantageous for that.</p>

      <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students? </p>

      <p>Campaigns like this one will showcase our staff achievements and hopefully, inspire future BAME students to pursue University. I like that within Faculty of Health and Education, the Pro-VC Alison Chambers provides a background of different festivals and wishes staff in her newsletters. I recently watched a video on how Netflix Netherlands prepares a relocation/new employee guide that is tailored to the individual’s ethnicity (alongside general information). For eg., details on Indian grocery shops or hair salons for Black employees etc. Such a guide would have really helped an international employee like me, who was new to Manchester, feel at home.</p>

      <p class="profile-statement-interviewer">What are you most proud of?</p>

      <p>I am proud of my journey and my dual identity. I will always be an Indian at heart. I am grateful to work with strong, inspiring women, who are my colleagues, mentors, and friends. They challenge and motivate me in the best way. My work atmosphere gives me positive vibes, which is very important to me as it makes me want to be here. I am glad to have found a place for myself and feel a sense of belonging.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  // .profile-container {
  // flex-direction: row-reverse;
  // }

  .profile-portrait-container {
    justify-content: flex-start;

    & figure {
      text-align: left;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }

</style>
